/* RESPONSIBLE TEAM: team-workflows */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable no-restricted-imports */
import { inject as service } from '@ember/service';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
import generateUUID from 'embercom/lib/uuid-generator';
import { INBOUND_BOT_TYPE } from 'embercom/lib/operator/custom-bots/constants';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  appService: service('app-service'),

  attrs: {
    visualBuilderObject: { embedded: 'always' },
    draftVisualBuilderObject: { embedded: 'always' },
  },

  normalize(modelClass, resourceHash) {
    resourceHash = this._normalizeSingleResource(resourceHash);
    return this._super(modelClass, resourceHash);
  },

  serialize(snapshot, options) {
    let serialized = this._super(...arguments);
    if (serialized.visual_builder_object) {
      this._serializeVisualBuilderObject(serialized);
      this._stripLocalizationsIfEnabled(serialized);
    }

    return serialized;
  },

  _stripLocalizationsIfEnabled(serialized) {
    let shouldExcludeLocalizations = this.appService?.app?.canUseFeature(
      'workflows-exclude-request-localizations',
    );

    if (shouldExcludeLocalizations && serialized.visual_builder_object) {
      let WorkflowModel = this.store.modelFor('operator/visual-builder/workflow');
      WorkflowModel.stripLocalizations(serialized.visual_builder_object);
    }
  },

  _normalizeSingleResource(response) {
    response.paths = this._normalizePaths(response.paths);
    this._normalizeVisualBuilderObject(response, 'visual_builder_object');
    this._normalizeVisualBuilderObject(response, 'draft_visual_builder_object');
    return response;
  },

  _normalizePaths(paths) {
    if (!paths) {
      return paths;
    }

    paths = paths.map((path) => ({
      ...path,
      _id: path.id,
    }));

    paths.forEach((path) => {
      path.steps = this._normalizeSteps(path.steps);
    });

    return paths;
  },

  _normalizeSteps(steps) {
    if (!steps) {
      return steps;
    }

    steps = steps.map((step) => {
      if (step.type === 'follow_up_rules' || step.type === 'answer_bot') {
        if (step.simple_action_rule === null) {
          step.simple_action_rule = this.store.createFragment('rules/rule');
        }
      }
      return step;
    });

    return steps;
  },

  _normalizeVisualBuilderObject(response, fieldName = 'visual_builder_object') {
    let visual_builder_object = response[fieldName];
    if (!visual_builder_object) {
      return;
    }
    // Create the capture composer input & placeholder group if required
    let startingGroup = visual_builder_object.groups.find((group) => group.is_start);
    let replyButtons = startingGroup.steps[startingGroup.steps.length - 1];

    if (response.type === INBOUND_BOT_TYPE) {
      let captureComposerInput = replyButtons.outward_connection_points.find(
        (button) => button.type === 'capture_composer_input',
      );

      if (!captureComposerInput && !replyButtons.is_composer_disabled) {
        let placeholderGroup = {
          id: generateUUID(),
          placeholder_name: 'capture-composer',
        };

        replyButtons.outward_connection_points.push({
          id: generateUUID(),
          type: 'capture_composer_input',
          edge: { to_group_id: placeholderGroup.id },
        });
        visual_builder_object.groups.push(placeholderGroup);
      } else if (captureComposerInput) {
        let targetGroup = visual_builder_object.groups.find(
          (group) => group.id === captureComposerInput.edge?.to_group_id,
        );

        if (targetGroup) {
          if (!targetGroup.placeholder_name) {
            targetGroup.placeholder_name = 'capture-composer';
          }
        } else {
          // Placeholder group was stripped by backend (empty groups with 0 steps get filtered)
          // This occurs when saving an inbound workflow as draft - the backend strips the
          // empty placeholder group but keeps the capture_composer_input connection point.
          // Create a new placeholder group and update the edge to point to it.
          let newPlaceholderGroup = {
            id: generateUUID(),
            placeholder_name: 'capture-composer',
          };
          visual_builder_object.groups.push(newPlaceholderGroup);

          // Update the edge to point to the new placeholder group
          if (captureComposerInput.edge) {
            captureComposerInput.edge.to_group_id = newPlaceholderGroup.id;
          } else {
            captureComposerInput.edge = { to_group_id: newPlaceholderGroup.id };
          }
        }
      }
    }
  },

  _serializeVisualBuilderObject(serialized) {
    let { visual_builder_object } = serialized;
    // Filter out empty placeholder groups
    visual_builder_object.groups = visual_builder_object.groups.filter(
      (group) => group.is_start || group.steps.length > 0,
    );

    // Delete the capture composer input if it's unconnected
    if (serialized.type === INBOUND_BOT_TYPE) {
      let startingGroup = visual_builder_object.groups.find((group) => group.is_start);
      let replyButtonsStep = startingGroup.steps[startingGroup.steps.length - 1];
      let unconnectedCaptureComposerInputIndex =
        replyButtonsStep.outward_connection_points.findIndex(
          (point) =>
            point.type === 'capture_composer_input' &&
            !visual_builder_object.groups.find((group) => group.id === point.edge?.to_group_id) &&
            !point.is_terminal,
        );

      if (unconnectedCaptureComposerInputIndex !== -1) {
        replyButtonsStep.outward_connection_points.splice(unconnectedCaptureComposerInputIndex, 1);
      }
    }
  },
});
